export enum LocalKey {
  statistics = 'statistics',
  backup_data = 'backup_data',
}
